export default {"src":"/_next/static/media/berachain.57304c86.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};